import cn from 'classnames'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Button, ButtonType } from '@UI/components/controls/Button/Button.tsx'
import { Xcross } from '@UI/components/icons/Xcross.tsx'
import { Colors } from '@UI/theme/generated/Colors.ts'
import { Body_14_Coral_Empasis_14 } from '@UI/typography/generated/typography.tsx'
import styles from './Modal.module.less'

export enum ModalType {
    dialog = 'dialog',
    window = 'window'
}

export interface Props extends React.PropsWithChildren {
    onClose?: () => void
    maxWidth?: number | string
    modalType?: ModalType
    title?: React.ReactNode | string
}

export const Modal: React.FC<Props> = ({ title, modalType = ModalType.dialog, maxWidth, children, onClose }) => {
    useEffect(() => {
        window.document.body.style.width = window.document.documentElement.clientWidth + 'px'
        window.document.body.style.overflow = 'hidden'
        return () => {
            window.document.body.style.overflow = 'initial'
            window.document.body.style.width = 'auto'
        }
    }, [])
    return createPortal(
        <div onClick={onClose} className={cn(styles.container, { [styles[modalType]]: modalType })}>
            <div className={styles.veil}></div>
            <div className={styles.modalContainer}>
                <div style={{ maxWidth }} onClick={e => e.stopPropagation()} className={styles.modal}>
                    {title && (
                        <div className={styles.header}>
                            <div className={styles.title}>
                                <Body_14_Coral_Empasis_14>{title}</Body_14_Coral_Empasis_14>
                            </div>
                            {modalType === ModalType.window && (
                                <div className={styles.closeButton}>
                                    <Button
                                        type={ButtonType.clickableIcon}
                                        onClick={onClose}
                                        icon={<Xcross size={20} color={Colors.Obsidian_Light_300} />}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    <div className={styles.body}>{children}</div>
                </div>
            </div>
        </div>,
        document.body
    )
}
